import { useContext, React, useEffect, useState } from "react";
import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";
import {
  AlignmentType,
  Document,
  //HeadingLevel,
  //HeadingLevel,
  BorderStyle,
  Footer,
  Packer,
  Paragraph,
  PageNumber,
  //PageBreak,
  Table,
  TableRow,
  ImageRun,
  //NumberFormat,
  //TabStopPosition,
  //TabStopType,
  //Tab,
  TableCell,
  VerticalAlign,
  WidthType,
  //TextDirection,
  TextRun,
  //Alignment,
} from "docx";
import axios from "axios";

export default function EnhRaporOzet() {
  
  const [isLoading,setIsLoading] = useState(false);
  

  const {
    API_URL,
    user,
    userKredi,
    setUserKredi,
    //dava verileri
    davaTarihi,
    dosyaYili,
    davaci,
    davali,
    dosyaNo,
    mahkemeTuru,
    dosyaTuru,
    davaTuru,
    //tasinmaz verileri
    secilenIlce,
    secilenSehir,
    tasinmazSecilenSehir,
    tasinmazSecilenIlce,
    tasinmazSecilenKoyMahalle,
    adaNo,
    parselNo,
    metreKare,
    mevkii,
    tasinmazVasfi,
    kamulasacakMetreKare,
    //tasinmazMalikleri,
    sulamaAciklama,
    malikListesi,
    tasinmazEgimi,
    araziYapisi,
    toprakBunyesi,
    koyeUzaklik,
    ilceUzaklik,
    kesifAnlatim,
    kesifTarihi,
    kapitalizasyonFaizOrani,
    evrakList,

    //objektifUnsurlar,

    //ağaçlar
    agacListesi,
    ormanAgacListesi,
    ormanAgaciVar,
    meyveVar,
    emlakBeyani,
    emlakBeyaniEvraki,
    oncekidegerlemevarmi,
    oncekidegerleme,
    //münavebe
    gelenListe,
    davaciAvukati,
    davaliAvukati,
    masrafUcteBirMi,

    //topNetGelir,
    ortNetGelir,
    odaToplam,

    //oncekidegerlemetoplamfiyat,
    setOncekiDegerlemeToplamFiyat,

    birinciBilirkisi,

    ikinciBilirkisi,

    ucuncuBilirkisi,

    dorduncuBilirkisi,

    besinciBilirkisi,

    altinciBilirkisi,

    //RESİMLER
    konumResim,

    birinciResim,

    ikinciResim,

    //ENH PARAMETRELERİ
    irtifakAlani,
    direkAlani,
  } = useContext(GlobalContext);

  const aylar = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const raporTarihi = new Date();



  const oncekidegerlemet = oncekidegerlemevarmi
    ? oncekidegerleme.oncekidegerlemetarih.slice(8, 10) +
      "." +
      oncekidegerleme.oncekidegerlemetarih.slice(5, 7) +
      "." +
      oncekidegerleme.oncekidegerlemetarih.slice(0, 4)
    : ".../.../....";
  const emlakt = emlakBeyaniEvraki
    ? emlakBeyaniEvraki.emlakbeyantarih.slice(8, 10) +
      "." +
      emlakBeyaniEvraki.emlakbeyantarih.slice(5, 7) +
      "." +
      emlakBeyaniEvraki.emlakbeyantarih.slice(0, 4)
    : ".../.../...."
  

  const dt = davaTarihi
    ? davaTarihi.slice(8, 10) +
      "." +
      davaTarihi.slice(5, 7) +
      "." +
      davaTarihi.slice(0, 4)
    : ".../.../....";

  const kt = kesifTarihi
    ? kesifTarihi.slice(8, 10) +
      "." +
      kesifTarihi.slice(5, 7) +
      "." +
      kesifTarihi.slice(0, 4)
    : ".../.../....";

  const evrakTarihi =
    evrakList.length > 0
      ? evrakList[0].tarih.slice(8, 10) +
        "." +
        evrakList[0].tarih.slice(5, 7) +
        "." +
        evrakList[0].tarih.slice(0, 4)
      : ".../.../....";

  //DEKAR BEDELİ
  const [ciplakarazidegeri, setCiplakAraziDegeri] = useState(0);
  const [odaEklenmisAraziDegeri, setodaEklenmisAraziDegeri] = useState(0);
  const [araziZeminBedeli, setAraziZeminBedeli] = useState(0);
  const [m2Fiyati, setM2Fiyati] = useState(0);

  useEffect(() => {
    var cad = ortNetGelir / kapitalizasyonFaizOrani;
    setCiplakAraziDegeri(cad);

    var odaad =
      ortNetGelir / kapitalizasyonFaizOrani +
      ((ortNetGelir / kapitalizasyonFaizOrani) * odaToplam) / 100;

    setodaEklenmisAraziDegeri(odaad);

    setAraziZeminBedeli((metreKare * odaad) / 1000);

    var m2detayli = parseFloat(odaad) / 1000;
    setM2Fiyati(m2detayli);

    var oncekidegerlemetoplamdeger = oncekidegerleme.oncekidegerlemetoplamfiyat;
    console.log("oncekidegerlenetoplamdeger :>> ", oncekidegerlemetoplamdeger);
    setOncekiDegerlemeToplamFiyat(oncekidegerlemetoplamdeger);
  }, []);


  var meyveAgaciFiyatToplami = 0;
  meyveVar &&
    agacListesi.map(
      (agac) =>
        (meyveAgaciFiyatToplami =
          meyveAgaciFiyatToplami +
          parseFloat(agac.adetFiyati).toFixed(2) *
            parseFloat(agac.agacAdet).toFixed(2))
    );

  var ormanAgaciFiyatToplami = 0;
  ormanAgaciVar &&
    ormanAgacListesi.map((agac) =>
      (ormanAgaciFiyatToplami =
        ormanAgaciFiyatToplami +
        ((((3.14 * parseFloat(agac.cap)) / 2) * parseFloat(agac.cap)) / 2) *
          parseFloat(agac.yukseklik) *
          parseFloat(agac.ormanAgaciAdet) *
          parseFloat(agac.m3Fiyati)).toFixed(2)
    );

  const toplamAgacFiyati = (
    meyveAgaciFiyatToplami + ormanAgaciFiyatToplami
  ).toFixed(2);



  const toplamAraziDegeri = (
    parseFloat(m2Fiyati) * parseFloat(metreKare) +
    parseFloat(toplamAgacFiyati)
  ).toFixed(2);

  const agacYapiEklenmisM2Fiyati = (
    parseFloat(toplamAraziDegeri) / parseFloat(metreKare)
  ).toFixed(2);

  const degerAzalisOrani = (
    (irtifakAlani / (metreKare - direkAlani)) *
    0.35
  ).toFixed(5);
  const daimiIrtifakBedeli = (
    (parseFloat(metreKare) - parseFloat(direkAlani)) *
    parseFloat(agacYapiEklenmisM2Fiyati) *
    parseFloat(degerAzalisOrani)
  ).toFixed(2);

  const pilonyeribedeli = (
    parseFloat(agacYapiEklenmisM2Fiyati) * parseFloat(direkAlani)
  ).toFixed(2);

  const irtifakTesisiToplamBedel = (
    parseFloat(pilonyeribedeli) + parseFloat(daimiIrtifakBedeli)
  ).toFixed(2);

  const meyveAgaciTablosu = () =>
    agacListesi &&
    agacListesi.map(
      (agac) =>
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph(agac.agacAdi)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.agacYasi)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.adetFiyati)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.agacAdet)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: (
                    parseFloat(agac.adetFiyati) * parseFloat(agac.agacAdet)
                  )
                    .toFixed(2)
                    .toString(),
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
          ],
        })
    );

  const ormanAgaciTablosu = () =>
    ormanAgacListesi &&
    ormanAgacListesi.map(
      (agac) =>
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph(agac.ormanAgacAdi)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.cap)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.yukseklik)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.ormanAgaciAdet)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [new Paragraph(agac.m3Fiyati)],
              verticalAlign: VerticalAlign.CENTER,
            }),
            new TableCell({
              children: [
                new Paragraph({
                  text: (
                    ((((3.14 * parseFloat(agac.cap)) / 2) *
                      parseFloat(agac.cap)) /
                      2) *
                    parseFloat(agac.yukseklik) *
                    parseFloat(agac.ormanAgaciAdet) *
                    parseFloat(agac.m3Fiyati)
                  )
                    .toFixed(2)
                    .toString(),
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
            }),
          ],
        })
    );

  //MÜNAVEBE TABLOSU OLUŞTURMA
  const munabebeTablosu = () =>
    masrafUcteBirMi
      ? gelenListe &&
        gelenListe.map(
          (urun) =>
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph(urun.urunAdi)],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.anaUrunVerim).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.anaUrunFiyat).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.yanUrunGelir).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      (
                        parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                        parseFloat(urun.yanUrunGelir)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      (
                        (parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                          parseFloat(urun.yanUrunGelir)) /
                        3
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      text: (
                        parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                        parseFloat(urun.yanUrunGelir) -
                        (parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                          parseFloat(urun.yanUrunGelir)) /
                          3
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }),
                    }),
                  ],
                }),
              ],
            })
        )
      : gelenListe &&
        gelenListe.map(
          (urun) =>
            new TableRow({
              children: [
                new TableCell({
                  children: [new Paragraph(urun.urunAdi)],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.anaUrunVerim).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.anaUrunFiyat).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.yanUrunGelir).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      (
                        parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                        parseFloat(urun.yanUrunGelir)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  children: [
                    new Paragraph(
                      parseFloat(urun.masraf).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ),
                  ],
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  verticalAlign: VerticalAlign.CENTER,
                  children: [
                    new Paragraph({
                      text: (
                        parseFloat(urun.anaUrunVerim) *
                          parseFloat(urun.anaUrunFiyat) +
                        parseFloat(urun.yanUrunGelir) -
                        parseFloat(urun.masraf)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }),
                    }),
                  ],
                }),
              ],
            })
        );


  //RAPOR OLUŞTURMA FONKSİYONU
  
const reduceCredit = async () => {
  if (!user || !userKredi || isNaN(parseInt(userKredi, 10))) {
    window.alert("Geçerli bir kullanıcı ve kredi miktarı giriniz.");
    return;
  }

  setIsLoading(true);

  try {
    const response = await axios.post(`${API_URL}/reduce-credit`, {
      username: user,
      userKredi: parseInt(userKredi, 10),
    });

    // Backend'den güncel kredi bilgisini al
    if (response.data?.updatedKredi !== undefined) {
      setUserKredi(response.data.updatedKredi);
    }

    window.alert(response.data?.message || "İşlem başarılı.");
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;
      const errorMessage = data?.error || "Bilinmeyen bir hata oluştu.";

      if (status === 401) {
        window.alert("Yetkiniz yok.");
      } else if (status === 400) {
        window.alert("Geçersiz istek.");
      } else {
        window.alert(errorMessage);
      }
    } else {
      console.error("Hata:", error);
      window.alert("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  } finally {
    setIsLoading(false);
  }
};
  
  const generate = () => {
    if (userKredi > 0) {
      try {
        const doc = new Document({
          sections: [
            {
              footers: {
                default: new Footer({
                  children: [
                    new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          children: ["Sayfa ", PageNumber.CURRENT],
                        }),
                        new TextRun({
                          children: [" / ", PageNumber.TOTAL_PAGES],
                        }),
                      ],
                    }),
                  ],
                }),
              },
              children: [
                //RAPOR BAŞLIĞI
                secilenIlce === "Merkez"
                  ? new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text:
                            "T.C. " + secilenSehir + " " + mahkemeTuru + "ne",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.CENTER,
                      children: [
                        new TextRun({
                          text:
                            "T.C. " + secilenIlce + " " + mahkemeTuru + "ne",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [
                    new TextRun({
                      text: "Bilirkişi Kurulu Raporudur",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //DOSYA NO
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text:
                        "Dosya No: " +
                        dosyaYili +
                        "/" +
                        dosyaNo +
                        " " +
                        dosyaTuru,
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //TARAFLAR
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Davacı: " + davaci,
                      bold: true,
                      fontsize: 12,
                    }),
                    davaciAvukati
                      ? new TextRun({
                          text: " Vekili " + davaciAvukati,
                          bold: true,
                          fontsize: 12,
                        })
                      : new TextRun({
                          text: " ",
                          bold: true,
                          fontsize: 12,
                        }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Davalı: " + davali,
                      bold: true,
                      fontsize: 12,
                    }),
                    davaliAvukati
                      ? new TextRun({
                          text: " Vekili " + davaliAvukati,
                          bold: true,
                          fontsize: 12,
                        })
                      : new TextRun({
                          text: "",
                          bold: true,
                          fontsize: 12,
                        }),
                  ],
                }),
                //DAVA KONUSU
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Dava Konusu: " + davaTuru,
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //DAVA TARİHİ
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Dava Tarihi: " + dt,
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //KEŞİF TARİHİ
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Keşif Tarihi: " + kt,
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "İnceleme Konusu: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        tasinmazSecilenSehir +
                        " İli " +
                        tasinmazSecilenIlce +
                        " İlçesi " +
                        tasinmazSecilenKoyMahalle +" "+
                        adaNo +
                        " Ada " +
                        parselNo +
                        " Parsel Numaralı " +
                        parseFloat(metreKare).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        " m2 Yüzölçümüne Sahip " +
                        tasinmazVasfi +
                        " Vasıflı Taşınmaz ",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Gözlenmesi Ve İncelenmesi İstenen Maddi Unsurlar: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Dava konusu taşınmaz üzerinde kurulacak irtifak tesisi ile kamulaştırma kanununun 11. Maddesi gereğince varsa direk yeri alanının değer tespiti ve daimi irtifak hakkı bedel tespiti yapılacaktır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Yukarıda tarafları belirtilen dosyada bilirkişi seçilmemiz üzerine " +
                        kt +
                        " tarihinde Sayın Hâkim ve ilgililerin iştiraki ile dava konusu taşınmazın bulunduğu alana gidildi. Mahallinde ve tarafımıza verilen evraklar üzerinde ve kadastro bilirkişilerinin gösterdiği alanlarda yapmış olduğumuz inceleme ve bunlara ilişkin sonuçlar aşağıda rapor halinde sunulmuştur.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "1-) DAVA KONUSU VE TALEP:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Davacı vekili " +
                        davaciAvukati +
                        " " +
                        dt +
                        " tarihli dilekçesi ile taşınmaz üzerinde kurulacak daimi irtifak hakkı bedelinin ve varsa direk yeri alanının bedel tespiti yapılarak davacı idare adına tescilini istemiştir.",
                      fontsize: 12,
                    }),
                  ],
                }),

                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "2-İNCELEME YÖNTEMİ VE BİLİMSEL VE TEKNİK DAYANAKLAR:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "2942 sayılı Kamulaştırma kanunu 11. Ve 12. Maddesi gereğince ve Sermaye Piyasası Kurulu tarafından kabul edilen değerleme standartlarına ve 6754 sayılı Bilirkişilik Kanunu ve Bilirkişilik Kanunu Yönetmeliğinin m.55 f.1 hükmü uyarınca bilirkişi raporunda yer alması gereken hususlar tarafımızca değerlendirilecektir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "3- TAŞINMAZA AİT BİLGİLER:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "a- Tapu Kaydına Göre: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: tasinmazVasfi ? tasinmazVasfi + "dır" : "Arazidir",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "b- İmar Planına Göre: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Taşınmaz İmar Planı Dışında olup vasfı Arazidir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c- Belediye Emlak Beyanına Göre: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: emlakBeyani
                        ? "Dava dosyasında bulunan " +
                          tasinmazSecilenIlce +
                          " " +
                          emlakBeyaniEvraki.emlakbeyankurum +
                          "'nün " +
                          emlakt +
                          " tarih ve " +
                          emlakBeyaniEvraki.emlakbeyanevrakno +
                          " sayılı yazılarında taşınmazın vergi beyan değerinin " +
                          emlakBeyaniEvraki.emlakbeyanevrakinOzu +
                          " TL/m2 olduğu bildirilmektedir."
                        : "Dava Dosyasında Belediye Emlak Servisi kaydına rastlanmamıştır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "d- Keşif Tarihindeki Durumuna Göre: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        "Keşif esnasında taşınmazın toprak yapısına ve sulama durumuna göre " +
                        araziYapisi +
                        " Arazi olduğu görülmüştür. " +
                        sulamaAciklama,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "e- Değerlemede Taşınmazın Cinsi: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Tarım Arazisi olarak kabul edilecektir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "f-Değerleme Yöntemi: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Değerlemede Taşınmazın m2 Birim Fiyatı Net Gelir Yöntemi ile Bulunacaktır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "4- YÜZÖLÇÜMÜ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "a- Tapu Alanı: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        parseFloat(metreKare).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) + " m2'dir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "b- Daimi İrtifak Alanın Yüzölçümü: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        parseFloat(irtifakAlani).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) + " m2'dir.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "c- Pilon Yeri Alanı: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        direkAlani > 0
                          ? parseFloat(direkAlani).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) + " m2'dir."
                          : "Taşınmazın taşınmaz üzerinde direk bulunmamaktadır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "5- KIYMETİNİ ETKİLEYEBİLECEK NİTELİK VE UNSURLARI ve TAŞINMAZIN ÖZELLİKLERİ;",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "a- TAPU KAYDINA GÖRE: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    malikListesi[0].adi === ""
                      ? new TextRun({
                          text: "Tapu kaydına göre taşınmazın .......................... hissesi ................................ adına kayıtlıdır.",
                          fontsize: 12,
                        })
                      : new TextRun({
                          text:
                            "Tapu kaydına göre taşınmazın" +
                            malikListesi.map((malik) => {
                              return (
                                " " +
                                malik.pay +
                                "/" +
                                malik.payda +
                                " Hissesi " +
                                malik.adi
                              );
                            }) +
                            " adına kayıtlıdır.",
                          fontsize: 12,
                        }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "b- KADASTRAL DURUMU: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: "Fen Bilirkişisi raporu ayrıca sunulmuştur.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c- İMAR PLANINA GÖRE: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        evrakList.length > 0
                          ? "Dosyada bulunan" +
                            evrakList.map((evrak) => {
                              return (
                                " " +
                                tasinmazSecilenIlce +
                                " " +
                                evrak.kurum +
                                "'nün " +
                                evrakTarihi +
                                " tarih ve " +
                                evrak.evrakno +
                                " sayılı"
                              );
                            }) +
                            " " +
                            "yazıları gereğince taşınmazın Arazi olduğu ve Değerlemede Arsa sayılabilmesi için gerekli şartları sağlamadığı anlaşılmıştır."
                          : "Dosya üzerinde yapılan incelemede ilgili kurumlarca gönderilen müzekkere cevaplarından taşınmazın Arazi olduğu ve Değerlemede Arsa sayılabilmesi için gerekli şartları sağlamadığı anlaşılmıştır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "d- KEŞİFTEKİ DURUMUNA GÖRE: ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text: kesifAnlatim
                        ? "Keşif günü taşınmazın " +
                          tasinmazVasfi +
                          " Arazi vasfında olduğu, bünye sınıfına göre toprak yapısının " +
                          toprakBunyesi +
                          " olduğu, ortalama eğimin %" +
                          tasinmazEgimi +
                          " civarında olduğu görülmüştür. " +
                          kesifAnlatim
                        : "Keşif günü taşınmazın " +
                          tasinmazVasfi +
                          " Arazi vasfında olduğu, bünye sınıfına göre toprak yapısının " +
                          toprakBunyesi +
                          " olduğu, ortalama eğimin %" +
                          tasinmazEgimi +
                          " civarında olduğu görülmüştür.",
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "e- TAŞINMAZ ÜZERİNDE BULUNAN YAPI, MÜTEMMİMCÜZ, MUHDESAT VE DİKİLİ UNSURLAR; ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //new Paragraph({}),
                //MEYVE AĞAÇLARI TABLOSU
                meyveVar &&
                  new Paragraph({
                    alignment: AlignmentType.BOTH,
                    children: [
                      new TextRun({
                        text: "Taşınmaz üzerinde aşağıda tür, yaş ve fiyat değerleri belirtilen ağaçlar bulunmaktadır.",
                        bold: false,
                        fontsize: 12,
                      }),
                    ],
                  }),
                meyveVar
                  ? new Table({
                      rows: [
                        //Tablo Başlığı
                        new TableRow({
                          children: [
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Adı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Yaşı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Fiyatı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Sayısı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Toplam",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                        //Tablo Başlığı
                        ...meyveAgaciTablosu(),
                        new TableRow({
                          children: [
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Toplam",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: meyveAgaciFiyatToplami
                                        .toFixed(2)
                                        .toString(),
                                      //text: ormanAgaciFiyatToplami.toString(),
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Taşınmaz üzerinde ekonomik değere sahip meyve ağacı bulunmamaktadır. ",
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({}),
                //ORMAN AĞAÇLARI TABLOSU
                ormanAgaciVar &&
                  new Paragraph({
                    alignment: AlignmentType.BOTH,
                    children: [
                      new TextRun({
                        text: "Taşınmaz üzerinde aşağıda tür, ebat ve fiyat değerleri belirtilen orman emvali ağaçlar bulunmaktadır.",
                        bold: false,
                        fontsize: 12,
                      }),
                    ],
                  }),
                ormanAgaciVar
                  ? new Table({
                      rows: [
                        //Tablo Başlığı
                        new TableRow({
                          children: [
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Adı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Çapı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Yüksekliği",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Ağaç Sayısı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Metreküp Fiyatı",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              width: {
                                size: 3505,
                                type: WidthType.DXA,
                              },
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Toplam",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                        //Tablo Başlığı
                        ...ormanAgaciTablosu(),
                        new TableRow({
                          children: [
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      text: "Toplam",
                                      bold: true,
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                            new TableCell({
                              verticalAlign: VerticalAlign.CENTER,
                              children: [
                                new Paragraph({
                                  alignment: AlignmentType.CENTER,
                                  children: [
                                    new TextRun({
                                      //text: meyveAgaciFiyatToplami.toString(),
                                      text: ormanAgaciFiyatToplami
                                        .toFixed(2)
                                        .toString(),
                                      fontsize: 12,
                                    }),
                                  ],
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Taşınmaz üzerinde ekonomik değere sahip orman emvali ağaç bulunmamaktadır. ",
                          fontsize: 12,
                        }),
                      ],
                    }),
                //f- TAŞINMAZIN KONUM VE DİGER ÖZELLİKLERİ:
                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "f- TAŞINMAZIN KONUM VE DİGER ÖZELLİKLERİ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),

                tasinmazSecilenIlce.includes("Merkez")
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Taşınmaz " + tasinmazSecilenKoyMahalle+" "+mevkii+" Mevkisinde bulunmakta olup, "+
                            tasinmazSecilenSehir +
                            " İl Merkezine " +
                            ilceUzaklik +
                            " metre, " +
                            tasinmazSecilenKoyMahalle +"ne "+
                            koyeUzaklik +
                            " metre mesafededir.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Taşınmaz " + tasinmazSecilenKoyMahalle+" "+mevkii+" Mevkisinde bulunmakta olup, "+
                            tasinmazSecilenIlce +
                            " İlçe Merkezine " +
                            ilceUzaklik +
                            " metre, " +
                            tasinmazSecilenKoyMahalle +"ne "+
                            koyeUzaklik +
                            " metre mesafededir.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({}),

                //TAŞINMAZ KONUMU
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "g- TAŞINMAZIN KONUMU",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new ImageRun({
                      type: "jpg" || "png",
                      data: konumResim,
                      transformation: {
                        width: 600,
                        height: 250,
                      },
                    }),
                  ],
                }),
                new Paragraph({}),

                //TAŞINMAZ RESİMLERİ
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "h- TAŞINMAZ RESİMLERİ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new ImageRun({
                      type: "jpg" || "png",
                      data: birinciResim,
                      transformation: {
                        width: 280,
                        height: 180,
                      },
                    }),
                    new TextRun({
                      text: "            ",
                      bold: true,
                      fontsize: 12,
                    }),
                    new ImageRun({
                      type: "jpg" || "png",
                      data: ikinciResim,
                      transformation: {
                        width: 280,
                        height: 180,
                      },
                    }),
                  ],
                }),
                new Paragraph({}),

                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "6- VERGİ BEYANI: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                //EMLAK BEYANI
                emlakBeyaniEvraki &&
                emlakBeyaniEvraki.emlakbeyankurum.includes("Büyükşehir")
                  ? new Paragraph({
                      alignment: AlignmentType.LEFT,
                      children: [
                        new TextRun({
                          text: emlakBeyani
                            ? "Dava dosyasında bulunan " +
                              tasinmazSecilenSehir +
                              " " +
                              emlakBeyaniEvraki.emlakbeyankurum +
                              "'nün " +
                              emlakt +
                              " tarih ve " +
                              emlakBeyaniEvraki.emlakbeyanevrakno +
                              " sayılı yazılarında taşınmazın vergi beyan değerinin " +
                              emlakBeyaniEvraki.emlakbeyanevrakinOzu +
                              " TL/m2 olduğu bildirilmektedir."
                            : "Dava Dosyasında Belediye Emlak Servisi kaydına rastlanmamıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.LEFT,
                      children: [
                        new TextRun({
                          text: emlakBeyani
                            ? "Dava dosyasında bulunan " +
                              tasinmazSecilenSehir+"/"+tasinmazSecilenIlce +
                              " " +
                              emlakBeyaniEvraki.emlakbeyankurum +
                              "'nün " +
                              emlakt +
                              " tarih ve " +
                              emlakBeyaniEvraki.emlakbeyanevrakno +
                              " sayılı yazılarında taşınmazın vergi beyan değerinin " +
                              emlakBeyaniEvraki.emlakbeyanevrakinOzu +
                              " TL/m2 olduğu bildirilmektedir."
                            : "Dava Dosyasında Belediye Emlak Servisi kaydına rastlanmamıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({}),
                //ÖNCEKİ KIYMET TAKDİRLERİ
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "7-KAMULAŞTIRMA TARİHİNDEKİ RESMİ MAKAMLARCA YAPILMIŞ KIYMET TAKDİRLERİ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: oncekidegerlemevarmi
                        ? "Dava dosyasında bulunan ve " +
                          oncekidegerleme.degerlemeyapankurum +
                          "'nce yapılan " +
                          oncekidegerlemet +
                          " tarihli Kıymet Takdir Raporunda taşınmaza " +
                          oncekidegerleme.oncekidegerlememetrekarefiyati +
                          " TL/m2 değer biçilmiş olup, kurulacak irtifak tesisi ve pilon yeri için " +
                          parseFloat(
                            oncekidegerleme.oncekidegerlemetoplamfiyat
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) +
                          " TL kamulaştırma bedeli takdir edilmiştir."
                        : "Dava Dosyasında önceki değerleme evrakına rastlanmamıştır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "8- ARAZİLERDE TAŞINMAZ MAL VE KAYNAĞIN MEVKİİ ŞARTLARINA GÖRE VE OLDUĞU GİBİ KULLANILMASI HALİNDE GETİRECEĞİ NET GELİR;",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "a- Kapitalizasyon Faiz Oranı;",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Kapitalizasyon Faiz Oranına yönelik hesaplamalarda yörede mevcut satışı yapılan alanlardaki değerlendirmeler, taşınmazın " +
                        araziYapisi +
                        " arazi olması ve " +
                        dosyaYili +
                        " yılı net gelir hesaplamaları da değerlendirilerek elde edilen kapitalizasyon faiz oranı %" +
                        (kapitalizasyonFaizOrani * 100).toString() +
                        " olarak kabul görmüştür.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //ODA
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "b- Objektif Değer Artış Oranı;",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),

                //ODA GEREKÇELERİ: SATIR İÇİ MAP ÖRNEĞİ
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    // new TextRun({
                    //   text:
                    //     odaToplam > 0
                    //       ? "Bilirkişi Kurulumuzca yapılan değerlendirmede " +
                    //         objektifUnsurlar.map((objektifunsur) => {
                    //           return (
                    //             " " +
                    //             objektifunsur.odaNedeni +
                    //             " nedeniyle " +
                    //             "%" +
                    //             objektifunsur.etkiOrani +
                    //             " "
                    //           );
                    //         }) +
                    //         " olmak üzere Toplam %" +
                    //         odaToplam.toString() +
                    //         " oranında objektif değer artış eklenmesi kanaati oluşmuştur."
                    //       : "Taşınmaz için yapılan net gelir hesapları ve taşınmaz ile ilgili yapılan değerlendirmeler sonucunda Bilirkişi Kurulumuzca taşınmazın değerine etki edecek objektif unsur bulunmadığı kararlaştırılmıştır.",
                    //   fontsize: 12,
                    // }),
                    new TextRun({
                      text:
                        odaToplam > 0
                          ? "Raporumuzun 6. maddesindeki taşınmazın konum ve diğer özelliklerinde belirtilen sebepler ile taşınmazın etrafında bulunan köylerin nüfus yoğunluğu ile tarıma olan ilginin fazla olması gibi sebeplerden dolayı bilirkişi kurulumuzca taşınmazın değerine %" +
                            odaToplam.toString() +
                            " oranında objektif değer artışı eklenmesi kanaati oluşmuştur."
                          : "Taşınmaz için yapılan net gelir hesapları ve taşınmaz ile ilgili yapılan değerlendirmeler sonucunda Bilirkişi Kurulumuzca taşınmazın değerine etki edecek objektif unsur bulunmadığı kararlaştırılmıştır.",
                      fontsize: 12,
                    }),
                  ],
                }),
                //NET GELİR
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c- TAŞINMAZIN NET GELİR VE METREKARE DEĞERİNİN HESAPLANMASI:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Taşınmazın Çıplak değeri (TÇD) (TL/da) = Net Gelir R (TL)/Kapitalizasyon Faiz Oranı (%) formülü ile hesap edilecektir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c-1- NET GELİRİN HESAPLANMASI TAŞINMAZIN ÇIPLAK ARAZİ DEĞERİ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                tasinmazSecilenIlce === "Merkez"
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Raporda kaynak olarak " +
                            tasinmazSecilenSehir +
                            " İl Tarım ve Orman Müdürlüğünün " +
                            dosyaYili +
                            " yılında geçerli " +
                            tasinmazSecilenSehir +
                            "/" +
                            tasinmazSecilenIlce +
                            " bölgesinde ağırlıklı olarak yetiştirilen bitkisel ürünlerin dekara verimi, tarladan toptan satış fiyatı cetvellerindeki gelir değerleri kullanılmıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Raporda kaynak olarak " +
                            tasinmazSecilenSehir +
                            " " +
                            tasinmazSecilenIlce +
                            " Tarım ve Orman Müdürlüğünün " +
                            dosyaYili +
                            " yılında geçerli " +
                            tasinmazSecilenSehir +
                            "/" +
                            tasinmazSecilenIlce +
                            " bölgesinde ağırlıklı olarak yetiştirilen bitkisel ürünlerin dekara verimi, tarladan toptan satış fiyatı cetvellerindeki gelir değerleri kullanılmıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),
                //Masrafın 3tebir alınıp alınmaması
                masrafUcteBirMi
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Masraf Değerleri için Brüt Gelirin 1/3'ü alınarak hesaplama yapılmıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Masraf Değerleri için ilgili Tarım Müdürlüğü verilerinde bulunan masraf değerleri ile hesaplama yapılmıştır.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Bilirkişi Kurulumuzca kıymet takdirinin " +
                        dosyaYili +
                        " yılı",
                      bold: false,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        gelenListe &&
                        gelenListe.map((urun) => {
                          return " " + urun.urunAdi;
                        }) +
                          " " +
                          "bitkilerinin münavebesi ile oluşacak ortalama net gelire göre değerlendirilmesi kararlaştırılmıştır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: dosyaYili + " Yılı",
                      bold: false,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        gelenListe &&
                        gelenListe.map((urun) => {
                          return " " + urun.urunAdi;
                        }) +
                          " " +
                          araziYapisi +
                          " Arazi",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //MÜNAVEBE TABLOSU
                new Table({
                  rows: [
                    //Tablo Başlığı
                    new TableRow({
                      children: [
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Ürün Adı",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Ana Ürün Verim",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Ana Ürün Fiyat",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Yan Ürün Gelir",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Toplam Gelir",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Masraf",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: "Net Gelir",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                    //Tablo Başlığı
                    //tablo satırları
                    ...munabebeTablosu(),
                  ],
                }),
                new Paragraph({}),
                //TABLO ALTI VERİLER
                masrafUcteBirMi
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Ortalama Net Gelir = ",
                          bold: false,
                          fontsize: 12,
                        }),
                        new TextRun({
                          text:
                            "(" +
                            gelenListe
                              .map((urun) =>
                                (
                                  parseFloat(urun.anaUrunVerim) *
                                    parseFloat(urun.anaUrunFiyat) +
                                  parseFloat(urun.yanUrunGelir) -
                                  (parseFloat(urun.anaUrunVerim) *
                                    parseFloat(urun.anaUrunFiyat) +
                                    parseFloat(urun.yanUrunGelir)) /
                                    3
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              )
                              .join("+") +
                            ")/" +
                            gelenListe.length.toString() +
                            " = " +
                            parseFloat(ortNetGelir).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " TL'dir.",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Ortalama Net Gelir = ",
                          bold: false,
                          fontsize: 12,
                        }),
                        new TextRun({
                          text:
                            "(" +
                            gelenListe
                              .map((urun) =>
                                (
                                  parseFloat(urun.anaUrunVerim) *
                                    parseFloat(urun.anaUrunFiyat) +
                                  parseFloat(urun.yanUrunGelir) -
                                  parseFloat(urun.masraf)
                                ).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              )
                              .join("+") +
                            ")/" +
                            gelenListe.length.toString() +
                            " = " +
                            parseFloat(ortNetGelir).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " TL'dir.",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    odaToplam > 0
                      ? new TextRun({
                          text: "Bir Dekar Arazi Değeri = (Ortalama Net Gelir / Kapitalizasyon Faiz Oranı) + (Objektif Değer Artışı)",
                          bold: false,
                          fontsize: 11,
                        })
                      : new TextRun({
                          text: "Bir Dekar Arazi Değeri = (Ortalama Net Gelir / Kapitalizasyon Faiz Oranı)",
                          bold: false,
                          fontsize: 11,
                        }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Bir Dekar Arazi Değeri =",
                      bold: false,
                      fontsize: 11,
                    }),
                    new TextRun({
                      text:
                        odaToplam > 0
                          ? parseFloat(ortNetGelir).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " TL/Da" +
                            " / " +
                            kapitalizasyonFaizOrani.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " + " +
                            ciplakarazidegeri.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " x " +
                            (odaToplam / 100).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " = " +
                            parseFloat(odaEklenmisAraziDegeri).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL/Da'dır."
                          : parseFloat(ortNetGelir).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " " +
                            "TL/Da" +
                            " / " +
                            kapitalizasyonFaizOrani.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " = " +
                            parseFloat(odaEklenmisAraziDegeri).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL/Da'dır.",
                      bold: false,
                      fontsize: 11,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Çıplak Arazi M2 Değeri = " +
                        parseFloat(m2Fiyati).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        " TL/m2'dir.",
                      bold: true,
                      fontsize: 11,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "İrtifak Öncesi Zemin Değeri= " +
                        parseFloat(m2Fiyati).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        " TL/m2 x " +
                        parseFloat(metreKare).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) +
                        " m2" +
                        " = " +
                        parseFloat(araziZeminBedeli).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })+" TL'dir.",
                      bold: true,
                      fontsize: 11,
                    }),
                  ],
                }),

                toplamAgacFiyati > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Taşınmaz Üzerinde Bulunan Ağaçların Değeri= " +
                            parseFloat(toplamAgacFiyati).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL'dir.",
                          bold: true,
                          fontsize: 11,
                        }),
                      ],
                    })
                  : "",
                toplamAgacFiyati > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "TAŞINMAZIN TOPLAM DEĞERİ= " +
                            parseFloat(toplamAraziDegeri).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL'dir.",
                          bold: true,
                          fontsize: 11,
                        }),
                      ],
                    })
                  : "",

                toplamAgacFiyati > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "ENH ÖNCESİ M2 DEĞERİ= " +
                            parseFloat(agacYapiEklenmisM2Fiyati).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL'dir.",
                          bold: true,
                          fontsize: 11,
                        }),
                      ],
                    })
                  : "",
                new Paragraph({}),
                //BURASI DEĞER AZALIŞI OLURSA YENİDEN DİZAYN EDİLECEK
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "9- TAŞINMAZIN İRTİFAK HAKKI TESİSİNDEN ETKİLENMESİ: ",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Taşınmaz dava konusu Enerji Nakil Hattı tesisinden aşağıda belirtilen sebeplerle etkilenmektedir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "a- Dava konusu taşınmaz üzerinde kurulması muhtemel tesislere ve tarımsal faaliyetlerde kullanılması zorunlu olan tarım alet ve makinalarına ELEKTRİK İŞLERİ KUVVETLİ AKIM YÖNETMELİĞİ Madde 44 Çizelge 8 itibari ile kısıtlamalar getirmektedir. Dolayısıyla çizelge 8'in getirdiği kısıtlamalar taşınmazı tamamen etkilemektedir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "b- Her ne kadar tesis irtifak hakkı tesisi ise de bu tesislerin bakım ve onarımı sırasında arazinin kendisi kullanılmakta ve tarımsal faaliyetler esnasında taşınmazın durumuna göre bellenmesi, sürümü ve diğer tarım ürünleri (Hububat, Sebze, v.s.) olumsuz yönde etkilenmektedir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "c- Kurulacak İrtifak Hakkı Tesisi araziyi tarımsal olarak işlemenin her sürecinde çalışanlar için ve taşınmaz üzerindeki tarımsal ürünler için yaşamsal muhtemel tehlike arz etmektedir. Tesisin biçimi itibari ile de bu tehlikeyi geniş bir alana yaymaktadır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "d- Taşınmaz üzerinde yapılacak ve yapılmış her türlü yatırımın geri dönüşüm riski artmıştır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "e- Dava konusu taşınmazın satış kabiliyeti azalacaktır, dolayısıyla irtifak hakkı tesisi taşınmazı bu şekilde de etkilemektedir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "f- Dava konusu taşınmaz üzerindeki irtifak hakkı tesisi, taşınmazın doğal güzelliğini bozacaktır, yani bir görüntü kirliliği meydana getirecektir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "10- DAİMİ İRTİFAK HAKKI SONUCU MEYDANA GELEN DEĞER EKSİLMESİ:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Yapılan Enerji Nakil Hattı taşınmaz üzerinde yetiştirilecek bitki türlerinin seçiminde bir kısıtlama unsuru taşımaktadır. Yine elektrik tellerinin yer yer değişik yüksekliklerde bulunuşu ve yüksek gerilim hattının elektrik akım etkileşimi nedeniyle tarımsal faaliyetlerde bir kısıtlama yaratması tesis inşaatı süresince arazinin rahat kullanılmaması, sabit tesislerin yapılamaması, bağ ve bahçe gibi sabit tesislerin yapılmasında bazı problemlerin doğması ve enerji nakil hattının altındaki arazide can ve mal emniyeti açısından kısıtlama olması nedeniyle tarım arazilerinde bir verim düşüklüğü meydana gelmektedir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Ayrıca muhtelif tarım alet ve makinelerinin kullanımı sırasında elektrik tellerinin mani teşkil etmesi de üretime etken unsurlar arasında yer almaktadır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Yukarıda açıklanan nedenlerden dolayı irtifak hakkı tesisi nedeniyle mevcut arazinin değerinde meydana gelen kıymet düşüklüğü, taşınmazın irtifak hakkı tesisi bedelini oluşturmaktadır. Dolayısıyla irtifak (üst geçit) suretiyle tesis edilen bu emniyet şeridinde tarım arazisinin kullanımı belli oranda azaltılmış olmaktadır.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Ancak arazinin değerindeki kıymet düşüklüğü, parselin büyüklüğüne, parsel üzerinde inşa edilen yüksek gerilim hattının konum ve koşullarına, halihazır şartlarda parsel üzerinde yapılan tarımsal faaliyetlerin niteliğine ve taşınmazın ulaşım durumuna bağlı olarak değişik alanlarda tespit edilmektedir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Bu nedenlerle dava konusu taşınmazın niteliği, tamamının yüzölçümü, geometrik durumu, daimi irtifak hakkı alınan bölümün konumu ve taşınmazdan geçtiği güzergah dikkate alınarak dava konusu taşınmaz üzerinde tesis edilen daimi irtifak nedeni ile meydana gelen değer azalış oranı, kurulumuzca aşağıdaki gibi tespit edilmiştir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({}),
                new Paragraph({}),

                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "PARSELDEKİ DEĞER AZALIŞ ORANI:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                direkAlani > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Daimi irtifak alanı/(Parselin Yüzölçümü - Pilon Alanı) x %35 olarak tespit edilmiştir.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Daimi irtifak alanı/Parselin Yüzölçümü x %35 olarak tespit edilmiştir.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),

                direkAlani > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            parseFloat(irtifakAlani).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " / (" +
                            parseFloat(metreKare).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " - " +
                            parseFloat(direkAlani).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            ") X 0,35 = " +
                            parseFloat(degerAzalisOrani).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 5,
                                maximumFractionDigits: 5,
                              }
                            ),
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            parseFloat(irtifakAlani).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " / " +
                            parseFloat(metreKare).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " X 0,35 = " +
                            parseFloat(degerAzalisOrani).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 5,
                                maximumFractionDigits: 5,
                              }
                            ),
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),

                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "11- DAİMİ İRTİFAK HAKKININ HESAPLANMASI:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                direkAlani > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Daimi İrtifak Bedeli (TL)= (Taşınmaz Alanı - Pilon Alanı) x M2 Değeri x Değer Azalış Oranı",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text: "Daimi İrtifak Bedeli (TL)= Taşınmaz Alanı x M2 Değeri x Değer Azalış Oranı",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),
                direkAlani > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Daimi İrtifak Bedeli (TL)= " +
                            "(" +
                            parseFloat(metreKare).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " - " +
                            parseFloat(direkAlani).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            ") X " +
                            parseFloat(agacYapiEklenmisM2Fiyati).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " X " +
                            parseFloat(degerAzalisOrani).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 5,
                                maximumFractionDigits: 5,
                              }
                            ),
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Daimi İrtifak Bedeli (TL)= " +
                            parseFloat(metreKare).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " X " +
                            parseFloat(agacYapiEklenmisM2Fiyati).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " X " +
                            parseFloat(degerAzalisOrani).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ),
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Daimi İrtifak Bedeli (TL)= " +
                        parseFloat(daimiIrtifakBedeli).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ) +
                        " TL'dir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),

                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "12- KURULUMUZCA TAKDİR EDİLEN DAİMİ İRTİFAK ve DİREK YERİ BEDELİ:",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Taşınmazın Toplam Alanı: " +
                        parseFloat(metreKare).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })+" m2'dir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "İrtifak Tesis Alanı: " +
                        parseFloat(irtifakAlani).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })+" m2'dir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                direkAlani > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Pilon Yeri Alanı: " +
                            parseFloat(direkAlani).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })+" m2'dir.",
                          bold: false,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : "",
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "İrtifak Tesisi Nedeniyle Gerçekleşen Değer Azalma Oranı: " +
                        parseFloat(degerAzalisOrani).toLocaleString(undefined, {
                          minimumFractionDigits: 5,
                          maximumFractionDigits: 5,
                        }),
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Daimi İrtifak Değeri: " +
                        parseFloat(daimiIrtifakBedeli).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        ) +
                        " TL'dir.",
                      bold: true,
                      fontsize: 12,
                    }),
                  ],
                }),
                direkAlani > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "Pilon Yeri Bedeli: " +
                            parseFloat(direkAlani).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })+" m2" +
                            " X " +
                            parseFloat(agacYapiEklenmisM2Fiyati).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +" TL/m2"+
                            " = " +
                            parseFloat(pilonyeribedeli).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL'dir.",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : "",
                direkAlani > 0
                  ? new Paragraph({
                      alignment: AlignmentType.BOTH,
                      children: [
                        new TextRun({
                          text:
                            "TOPLAM BEDEL: " +
                            parseFloat(irtifakTesisiToplamBedel).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            ) +
                            " TL'dir.",
                          bold: true,
                          fontsize: 12,
                        }),
                      ],
                    })
                  : "",

                irtifakTesisiToplamBedel > 0 && new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "Taşınmazın",
                      bold: false,
                      fontsize: 12,
                    }),
                    new TextRun({
                      text:
                        "" +
                        malikListesi.map((malik) => {
                          return (
                            " " +
                            malik.pay +
                            "/" +
                            malik.payda +
                            " Hissesi " +
                            malik.adi +
                            " adına kayıtlı olduğundan hissesine: " +
                            (
                              (parseFloat(irtifakTesisiToplamBedel) /
                                parseFloat(malik.payda)) *
                              parseFloat(malik.pay)
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) +
                            " TL"
                          );
                        }) +
                        " kamulaştırma bedeli isabet etmektedir.",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),

                new Paragraph({}),
                new Paragraph({}),
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text:
                        "Görüş ve kanaatimizi içeren iş bu bilirkişi raporunda 6754 sayılı Bilirkişilik Kanunu ve Bilirkişilik Kanunu Yönetmeliğinin m.55 f.1 hükmü uyarınca bilirkişi raporunda yer alması gereken hususlar tarafımızca değerlendirilmiş olup, Nihai Takdir Mahkemenize ait olmak üzere saygılarımızla arz ederiz. " +
                        raporTarihi.getDate() +
                        "." +
                        aylar[raporTarihi.getMonth()] +
                        "." +
                        raporTarihi.getFullYear(),
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //boş paragraf
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //boş paragraf
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                //boş paragraf
                new Paragraph({
                  alignment: AlignmentType.BOTH,
                  children: [
                    new TextRun({
                      text: "",
                      bold: false,
                      fontsize: 12,
                    }),
                  ],
                }),
                new Table({
                  rows: [
                    new TableRow({
                      children: [
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ikinciBilirkisi
                                    ? ikinciBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ikinciBilirkisi
                                    ? ikinciBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ikinciBilirkisi
                                    ? ikinciBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ucuncuBilirkisi
                                    ? ucuncuBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ucuncuBilirkisi
                                    ? ucuncuBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: ucuncuBilirkisi
                                    ? ucuncuBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          width: {
                            size: 3505,
                            type: WidthType.DXA,
                          },
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: birinciBilirkisi
                                    ? birinciBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: birinciBilirkisi
                                    ? birinciBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: birinciBilirkisi
                                    ? birinciBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),

                    new TableRow({
                      children: [
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: besinciBilirkisi
                                    ? besinciBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: besinciBilirkisi
                                    ? besinciBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: besinciBilirkisi
                                    ? besinciBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: dorduncuBilirkisi
                                    ? dorduncuBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: dorduncuBilirkisi
                                    ? dorduncuBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: dorduncuBilirkisi
                                    ? dorduncuBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                        new TableCell({
                          verticalAlign: VerticalAlign.CENTER,
                          borders: {
                            top: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "FF0000",
                            },
                            bottom: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "0000FF",
                            },
                            left: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "00FF00",
                            },
                            right: {
                              style: BorderStyle.NONE,
                              size: 3,
                              color: "#ff8000",
                            },
                          },
                          children: [
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: altinciBilirkisi
                                    ? altinciBilirkisi[0].name
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: altinciBilirkisi
                                    ? altinciBilirkisi[0].bilirkisiUnvani
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                            new Paragraph({
                              alignment: AlignmentType.CENTER,
                              children: [
                                new TextRun({
                                  text: altinciBilirkisi
                                    ? altinciBilirkisi[0].bilirkisiSicilNo
                                    : "",
                                  bold: true,
                                  fontsize: 12,
                                }),
                              ],
                            }),
                          ],
                        }),
                      ],
                    }),
                  ],
                }),
              ],
            },
          ],
        });

        Packer.toBlob(doc).then((blob) => {
          console.log(blob);
          saveAs(blob, "example.docx");
          console.log("Document created successfully");

          reduceCredit();
        });
      } catch (error) {
        alert("Münavebe Tablosunu Kontrol Ediniz");
      }
    } else {
      window.alert("Krediniz Kalmadı. Lüften Bağış Yapınız :(");
    }
  };

  return (
    <GlobalProvider>
      <div className="container">
        <h1 className="my-5 text-center">RAPOR ÖZETİ</h1>
        <table className="table table-bordered">
          <thead className="text-center">
            <tr>
              <th>Dosya Bilgileri</th>
              <th>Taşınmaz Bilgileri</th>
              <th>Arazi Özellikleri</th>
              <th>Değerleme Verileri</th>
              <th>Ağaç Bilgileri</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>
                  <b>ADLİYE:</b> {secilenSehir}/{secilenIlce}
                </p>
                <p>
                  <b>MAHKEME:</b> {mahkemeTuru}
                </p>
                <p>
                  <b>DOSYA YILI/NO:</b> {dosyaYili}/{dosyaNo} {dosyaTuru}
                </p>
                <p>
                  <b>DAVA KONUSU:</b> {davaTuru}
                </p>
                <p>
                  <b>DAVACI:</b> {davaci}
                </p>
                <p>
                  <b>DAVALI:</b> {davali}
                </p>
                <p>
                  <b>DAVA TARİHİ:</b> {dt}
                </p>
                <p>
                  <b>KEŞİF TARİHİ:</b> {kt}
                </p>
              </td>
              <td>
                <p>
                  <b>İL/İLÇE:</b> {tasinmazSecilenSehir}/{tasinmazSecilenIlce}
                </p>
                <p>
                  <b>KÖY MAHALLE:</b> {tasinmazSecilenKoyMahalle}
                </p>
                <p>
                  <b>ADA:</b> {adaNo}
                </p>
                <p>
                  <b>PARSEL:</b> {parselNo}
                </p>
                <p>
                  <b>ALAN:</b> {metreKare}
                </p>
                <p>
                  <b>MEVKİİ:</b> {mevkii}
                </p>
                <p>
                  <b>TAŞINMAZ VASFI:</b> {tasinmazVasfi}
                </p>
                <p>
                  <b>İRTİFAK ALANI:</b> {irtifakAlani}
                </p>

                <p>
                  <b>KAMULAŞTIRMA ALANI:</b> {kamulasacakMetreKare}
                </p>
                <p>
                  <b>TAŞINMAZ MALİKLERİ:</b>{" "}
                  {malikListesi.map(
                    (malik) =>
                      malik.pay +
                      "/" +
                      malik.payda +
                      " Hissesi " +
                      malik.adi +
                      " "
                  )}
                </p>
              </td>
              <td>
                <p>
                  <b>EĞİM:</b> %{tasinmazEgimi}
                </p>
                <p>
                  <b>ARAZİ YAPISI:</b> {araziYapisi}
                </p>
                <p>
                  <b>TOPRAK BÜNYESİ:</b> {toprakBunyesi}
                </p>
                <p>
                  <b>KÖYE UZAKLIK:</b> {koyeUzaklik}
                </p>
                <p>
                  <b>İLÇEYE UZAKLIK:</b> {ilceUzaklik}
                </p>
                <p>
                  <b>KEŞFE DAİR ANLATIMLAR:</b> {kesifAnlatim}
                </p>
              </td>
              <td>
                <p>
                  <b>ORTALAMA NET GELİR:</b> {ortNetGelir.toFixed(2)}
                </p>
                <p>
                  <b>KFO:</b> {kapitalizasyonFaizOrani}
                </p>
                <p>
                  <b>ARAZİ DEĞERİ:</b> {ciplakarazidegeri.toFixed(2)} TL/DA
                </p>
                <p>
                  <b>ODA:</b> %{odaToplam}
                </p>
                <p>
                  <b>ODA İLE ARAZİ D.:</b> {odaEklenmisAraziDegeri} TL/DA
                </p>
              </td>
              <td>
                <p>
                  <b>MEYVE AĞAÇLARI:</b>{" "}
                  {agacListesi.length > 0
                    ? agacListesi.map(
                        (agac) => agac.agacAdi.toUpperCase() + " "
                      )
                    : "Yok"}
                </p>
                <p>
                  <b>ORMAN AĞAÇLARI:</b>{" "}
                  {ormanAgacListesi.length > 0
                    ? ormanAgacListesi.map(
                        (agac) => agac.ormanAgacAdi.toUpperCase() + " "
                      )
                    : "Yok"}
                </p>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="row mt-5">
          <div className="col-6 text-start">
            <Link to="/enhresimekle">
              <button className="btn btn-success btn-lg">Resim Ekleme</button>
            </Link>
          </div>
          <div className="col-6 text-end">
            <button onClick={generate} className="btn btn-primary btn-lg">
              Rapor Yaz
            </button>
          </div>
        </div>
      </div>

      <div></div>
    </GlobalProvider>
  );
}